import { ROUTES } from 'constants/routes'
import * as Pages from 'pages'
import type { RouteObject } from 'react-router-dom'

import { PrivateRoute } from './private'

const orderServicesRoutes: RouteObject[] = [
  {
    path: ROUTES.ORDER_SERVICES.LIST,
    element: (
      <PrivateRoute>
        <Pages.OrderServices />
      </PrivateRoute>
    ),
  },
  {
    path: ROUTES.ORDER_SERVICES.CREATE,
    element: (
      <PrivateRoute>
        <Pages.AddOrderServices />
      </PrivateRoute>
    ),
  },
  {
    path: ROUTES.ORDER_SERVICES.EDIT(':id'),
    element: (
      <PrivateRoute>
        <Pages.EditOrderServices />
      </PrivateRoute>
    ),
  },
]

export default orderServicesRoutes
